import SortingPanel from "./SortingPanel"

export default SortingPanel;